function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect } from "react";
import { useBoolean } from "ahooks";
import debounce from "lodash/debounce";
import cx from "classnames";
import { ToTopFillIcon } from "@t8891/icon";
var classPrefix = "tc-back-top";
var BackTop = function BackTop(props) {
  var className = props.className,
    style = props.style,
    _props$screen = props.screen,
    screen = _props$screen === void 0 ? 2 : _props$screen,
    icon = props.icon,
    _onClick = props.onClick;
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    isShow = _useBoolean2[0],
    _useBoolean2$ = _useBoolean2[1],
    setTrue = _useBoolean2$.setTrue,
    setFalse = _useBoolean2$.setFalse;
  var handleScroll = debounce(function () {
    var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0;
    var screenHeight = window.screen.height * screen;
    if (screenHeight < scrollTop) {
      setTrue();
    } else if (screenHeight > scrollTop) {
      setFalse();
    }
  }, 50);
  var baseProps = {
    style: style,
    className: cx(classPrefix, className),
    onClick: function onClick() {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0;
      if (!!_onClick) {
        _onClick(scrollTop);
      }
      window.scrollTo(0, 0);
    }
  };
  useEffect(function () {
    if (typeof window === "undefined") return;
    window.addEventListener("scroll", function () {
      return handleScroll();
    });
    return function () {
      window.removeEventListener("scroll", function () {
        return handleScroll();
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShow && /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), icon !== null && icon !== void 0 ? icon : /*#__PURE__*/React.createElement(ToTopFillIcon, {
    size: 60
  })));
};
BackTop.defaultProps = {
  screen: 2
};
export default BackTop;